import React from 'react';
import PropTypes from 'prop-types';

import { NavLink } from 'react-router-dom';
import logo from '../../assets/images/TraceGenomics_white.png';
import { logoutUser } from '../auth/auth-actions';
import {
  StyledSideNavBar,
  StyledSideNavBarNavItem,
  StyledAbsoluteStickyWrapper } from './styles';
import { ReactComponent as GrowersIcon } from '../../common/svgs/Growers.svg';
import { ReactComponent as EnhanceIcon } from '../../common/svgs/Enhance.svg';
import { ReactComponent as InsightsIcon } from '../../common/svgs/Insights.svg';
import { ReactComponent as MapsIcon } from '../../common/svgs/Maps.svg';
import { ReactComponent as SamplesIcon } from '../../common/svgs/Samples.svg';
import UserLinks from './UserLinks';


const routes = [
  {
    to: '/growers',
    icon: GrowersIcon,
    title: 'Growers'
  },
  {
    to: '/insights',
    icon: InsightsIcon,
    title: 'Insights'
  },
  {
    to: '/field-management',
    icon: MapsIcon,
    title: 'Maps'
  },
  {
    to: '/enhance',
    icon: EnhanceIcon,
    title: 'Enhance'
  },
  {
    to: '/samples',
    icon: SamplesIcon,
    title: 'Samples'
  },
]


const MainNavLinks = ({ pathname, to, Icon, title }) => {
  return (
    <StyledSideNavBarNavItem>
      <NavLink to={to} className={(pathname === to) ? 'open' : ''}>
        <Icon />
        {title}
      </NavLink>
    </StyledSideNavBarNavItem>
  )
}
const SideNavBar = (props)=>{
  const { currentUser, dispatch, pathname, overrideStyle, unreleasedVisible } = props;
  if (!unreleasedVisible) return <></>
  return (
    <StyledAbsoluteStickyWrapper >
      <StyledSideNavBar style={overrideStyle}>
        <div className="link-wrapper">
          <NavLink to="/" className="navbar-brand">
            <img src={logo} alt="Trace Genomics Logo" />
          </NavLink>
          <div className="link-container">
            {
              routes.map((route) => {
                return (
                  <MainNavLinks
                    key={route.to}
                    pathname={pathname}
                    to={route.to}
                    Icon={route.icon}
                    title={route.title}
                  />
                );
              })
            }
            <StyledSideNavBarNavItem>
              <NavLink to='/dashboard'>View Legacy App</NavLink>
            </StyledSideNavBarNavItem>
          </div>
        </div>
        <UserLinks
          currentUser={currentUser}
          pathname={pathname}
          logOut={() => dispatch(logoutUser())}
        />
      </StyledSideNavBar>
    </StyledAbsoluteStickyWrapper >
  )
}

MainNavLinks.propTypes = {
  Icon: PropTypes.object.isRequired,
  to: PropTypes.string.isRequired,
  pathname: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default SideNavBar

